/** @format */

import { updateImagePath } from "../../common/helpers/arrayHelpers";

import {
	ADD_BOOKMARK,
	SET_ANIME_DETAILS,
	SET_ANIME_LIST,
	SET_APP_DATA,
	SET_GENRE,
	SET_IS_LOADED,
	SET_LATEST_ANIME,
	SET_MOVIES,
	SET_NEWS,
	SET_RECENTLY_ADDED,
	SET_RECOMMENDED_LIST,
	SET_SEARCH_RESULT,
	SET_SEARCH_STATUS,
	SET_STUDIO_LIST,
	SET_TRENDING_NOW,
	UPDATE_ANIME_LIST,
	UPDATE_NEWS,
} from "../variables";
//a promise resolver function
export function AppDataReducer(state, action) {
	switch (action.type) {
		case SET_APP_DATA:
			return {
				...state,
				appData: action.payload,
			};

		//To set and Update Anime List
		case SET_ANIME_LIST:
			return {
				...state,
				animeList: updateImagePath(action.payload),
			};

		case SET_LATEST_ANIME:
			return {
				...state,
				latestAnime: updateImagePath(action.payload),
			};

		case SET_RECENTLY_ADDED:
			return {
				...state,
				recentlyAdded: updateImagePath(action.payload),
			};

		case UPDATE_ANIME_LIST:
			return {
				...state,
				animeList: [...state.anime, action.payload],
			};

		case SET_ANIME_DETAILS:
			//changing the key to config.API_PARAMS.cover_image
			//as we need to update it frequently

			return {
				...state,
				animeDetails: action.payload,
			};

		//To set and update Anime news
		case SET_NEWS:
			return {
				...state,
				news: updateImagePath(action.payload),
			};

		case UPDATE_NEWS:
			return {
				...state,
				news: [...state.news, action.payload],
			};

		case SET_GENRE:
			return {
				...state,
				genre: action.payload,
			};

		case SET_TRENDING_NOW:
			return {
				...state,
				trendingNow: updateImagePath(action.payload),
			};

		case SET_STUDIO_LIST:
			return {
				...state,
				studioList: action.payload,
			};
		case SET_RECOMMENDED_LIST:
			return {
				...state,
				recommendationAnime: updateImagePath(action.payload),
			};

		case ADD_BOOKMARK:
			return {
				...state,
				recommendationAnime: action.payload,
			};

		case SET_IS_LOADED:
			return {
				...state,
				isLoaded: {
					value: true,
					time: Date.now(),
				},
			};

		case SET_SEARCH_RESULT:
			return {
				...state,
				search: {
					...state.search,
					results: updateImagePath(action.payload),
				},
			};
		case SET_SEARCH_STATUS:
			return {
				...state,
				search: {
					...state.search,
					status: action.payload,
				},
			};
		case SET_MOVIES:
			return {
				...state,
				movies: updateImagePath(action.payload),
			};

		default:
			return state;
		//end of switch
	}
}